import React, { useEffect, useState } from 'react';

import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { BreadCrumb, Loader } from '../../Common';
import { Container } from 'reactstrap';

import { Constant } from '../../Helpers/constant';
import Table from './Components/Tables/Table';
import { GET_DUPLICATE_CARD, GET_DUPLICATE_CARD_EMPTY } from '../../../store/application/actionType';

const DuplicateCardsManagement = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  /* ---------------------------- LOCAL STATES ---------------------------- */
  const [loading, setLoading] = useState(false);

  const [currentPageNumber, setCurrentPageNumber] = useState(0);
  const [currentPageIndex, setCurrentPageIndex] = useState(0);

  const [currentSelectedBookingDetails, setCurrentSelectedBookingDetails] = useState([]);

  /* ---------------------------- REDUX STATES ---------------------------- */
  // Duplicate Cards List
  const { duplicateCards, duplicateCardsLoading, duplicateCardsError } = useSelector(state => ({
    duplicateCards: state?.DuplicateCards?.data,
    duplicateCardsLoading: state?.DuplicateCards?.loading,
    duplicateCardsError: state?.DuplicateCards?.error,
  }));

  /* ---------------------------- DISPATCHING ---------------------------- */
  useEffect(() => {
    if (duplicateCards === null) {
      dispatch({
        type: GET_DUPLICATE_CARD,
        payload: {
          urlParam: {
            pageIndex: currentPageIndex,
          },
        },
      });
    }
  }, [dispatch]);

  useEffect(() => {
    return () => {
      dispatch({
        type: GET_DUPLICATE_CARD_EMPTY,
      });
    };
  }, [dispatch]);

  /* ---------------------------- TABLE ACTION HANDLER ---------------------------- */
  const tableActionHandler = params => {
    // if (params?.actionType === `DOWNLOAD`) {
    //   setCurrentSelectedBookingDetails(params?.downloadDetails)
    //   window.open(params?.downloadDetails?.file, `_blank`)
    // }
  };

  /* ---------------------------- PAGINATION HANDLER ---------------------------- */
  const paginationHandler = pageNumber => {
    setCurrentPageNumber(pageNumber);
    setCurrentPageIndex(pageNumber * Constant.TABLE_PAGE_SIZE);

    dispatch({
      type: GET_DUPLICATE_CARD,
      payload: {
        urlParam: {
          pageIndex: pageNumber * Constant.TABLE_PAGE_SIZE,
        },
      },
    });
  };

  /* ---------------------------- REFRESH HANDLER ---------------------------- */
  const refreshHandler = () => {
    dispatch({
      type: GET_DUPLICATE_CARD,
      payload: {
        urlParam: {
          pageIndex: currentPageIndex,
        },
      },
    });
  };

  /* ---------------------------- LOADING HANDLER ---------------------------- */
  useEffect(() => {
    if (duplicateCardsLoading) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [duplicateCardsLoading]);

  /* ---------------------------- BREADCRUM HANDLER ---------------------------- */
  const breadcrumNavigationHandler = title => {
    if (title === `Dashboard`) {
      history.push(`/dashboard`);
    } else if (title === `Duplicate Cards`) {
      // do nothing
    }
  };

  return (
    <>
      {loading && <Loader />}

      <div className="page-content">
        <Container fluid className="position-relative">
          <BreadCrumb title="Duplicate Cards" navigationby={breadcrumNavigationHandler} navigation={[`Dashboard`, `Duplicate Cards`]} />
          <Table
            data={duplicateCards?.results}
            totalData={duplicateCards?.count}
            pageNumber={currentPageNumber}
            dataStartedFrom={currentPageIndex}
            pageHandler={paginationHandler}
            actionHandler={tableActionHandler}
            refreshHandler={refreshHandler}
          />
        </Container>
      </div>
    </>
  );
};

export default DuplicateCardsManagement;
